import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';

const SuccessPage = ({ formData, vehicleAmount, monthlyPayment, term, handleGoBack }) => {
    return (
        <Container className="py-5">
            <Card className="border-0 shadow-sm">
                <Card.Body className="p-5 text-center">
                    <div className="success-icon mb-4">
                        <div className="circle-success">
                            <FaCheck size={42} className="text-white" />
                        </div>
                    </div>
                    <h2 className="mb-3">Tebrikler! Başvurunuz Alınmıştır</h2>
                    <p className="lead mb-4">
                        Araç finansman başvurunuz başarıyla oluşturuldu. Ekibimiz en kısa sürede
                        başvurunuzu değerlendirecek ve sizinle iletişime geçecektir.
                    </p>
                    <div className="application-summary mb-4">
                        <Row className="mb-2">
                            <Col xs={6} className="text-start">Araç Bedeli:</Col>
                            <Col xs={6} className="text-end fw-bold">₺ {vehicleAmount.toLocaleString('tr-TR')}</Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs={6} className="text-start">Aylık Ödeme:</Col>
                            <Col xs={6} className="text-end fw-bold">₺ {monthlyPayment.toLocaleString('tr-TR')}</Col>
                        </Row>
                        <Row>
                            <Col xs={6} className="text-start">Vade:</Col>
                            <Col xs={6} className="text-end fw-bold">{term} Ay</Col>
                        </Row>
                    </div>
                    <p className="text-muted mb-4">
                        Başvurunuzun bir kopyası <strong>{formData.email}</strong> adresine gönderilmiştir.
                        <br />Sorularınız için <strong>0532 387 30 91</strong> numaralı telefondan bize ulaşabilirsiniz.
                    </p>
                    <Button variant="primary" onClick={handleGoBack} className="mt-3">
                        Ana Sayfaya Dön
                    </Button>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default SuccessPage;